
$(document).ready(function () {

    var loadedColor = $(`#SingleOptionSelector-0`).children("option:selected").val(); // the selected color on page load
    // console.log("loadedColor", loadedColor);
    var userSelectedSize = false;
    /****************************************************************************************************************
        // capture all thumbnail slides so we can rebuild on color change
    ****************************************************************************************************************/
    var allThumbnails = [];
    $(`.product-v2--gallery-grid .product-v2--grid-item`).each(function () { allThumbnails.push($(this)); });
    $(`.product-v2--gallery-grid-rebuild .product-v2--grid-item`).each(function () { allThumbnails.push($(this)); });
    $(`.product-v2--gallery-selector .product-v2--grid-item`).each(function () { allThumbnails.push($(this)); });
    /****************************************************************************************************************
        // capture all sizes so we can rebuild size selector on color change
    ****************************************************************************************************************/
    var allSizeSelectOptions = [];
    $('#SingleOptionSelector-1 option').each(function () { allSizeSelectOptions.push($(this)); });
    /****************************************************************************************************************
        // initialize our UI elements
    ****************************************************************************************************************/
    SetSizeSelect(loadedColor, allSizeSelectOptions);
    SetImages(loadedColor, allThumbnails);
    SetColorName(loadedColor);
    /****************************************************************************************************************
        // update color select when a swatch is clicked
    ****************************************************************************************************************/
    $(".pdp-swatch").click(function () {
        $("#SingleOptionSelector-0").val($(this).attr("data-color"));
        $("#SingleOptionSelector-0").change(); // manuall fire so our sizes on(change) function runs
        $("#SingleOptionSelector-0").click();
        $(".pdp-swatch").removeClass('active');
        $(this).addClass('active');
        if (screen.width < 768) {
            $('.slick-dots li:first-child').click();
        }
    });

    /****************************************************************************************************************
        // select size and assign it to the hidden dropdown
    ****************************************************************************************************************/
    $(".pdp-size-swatch:not(.out-of-stock)").click(function () {
        $(".pdp-size-swatch").removeClass('active');
        $(this).addClass('active');
        var productID = $(this).data('id');
        var targetOption = $(`#SingleOptionSelector-1 option[data-id='${productID}']`).val();
        $("#SingleOptionSelector-1").val(targetOption).trigger("change");
        $("#SingleOptionSelector-1").click();
        userSelectedSize = true;
    });
    /****************************************************************************************************************
        // update sizes select whenever a new color is chosen
    ****************************************************************************************************************/
    $("#SingleOptionSelector-0").on('change', function () {
        userSelectedSize = false;
        var selectedColor = $(this).children("option:selected").val();
        SetSizeSelect(selectedColor, allSizeSelectOptions);
        SetImages(selectedColor, allThumbnails);
        SetColorName(selectedColor);
    });
    $(".pdp-size-swatch").on('click', function (e) {
        $('.pdp-error:visible').slideUp(100);
        $('.payment_button_form').removeClass('disabled');
    });

    $(".js-go-cart-add-to-cart-new").on('click', function (e) {

        if (userSelectedSize == false) {
            e.preventDefault();
            e.stopPropagation();
            $('.pdp-error').slideDown(100);
        } else {
            $('.pdp-error:visible').slideUp(100);
        }
    });

    $(".payment_button_form").addClass('disabled');

    $(".payment_button_form").on('click', function (e) {
        if (userSelectedSize == false) {
            e.preventDefault();
            e.stopPropagation();

            $(this).addClass('disabled');
        } else {

            $(this).removeClass('disabled');
        }
    });
    $(".payment_button_form--section").on('click', function (e) {
        if ($(".payment_button_form").hasClass('disabled')) {
            e.preventDefault(); 
            e.stopPropagation(); 
            $('.pdp-error').slideDown(100);
        }
    });
    $(".scroll_sticky_btn").on('click', function (e) {
        if (userSelectedSize == false) {
            e.preventDefault();
            e.stopPropagation();
            if (screen.width < 768) {
                var smoothCountElement = document.querySelector(".product--form");
                if (smoothCountElement) {
                    var headerOffset = 120;
                    var elementPosition = smoothCountElement.getBoundingClientRect().top;
                    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                } else {
                    var headerOffset = 120;
                    var elementPosition = smoothCountElement.getBoundingClientRect().top;
                    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }

            } else {
                var smoothCountElement = document.querySelector(".product--form");
                if (smoothCountElement) {
                    var headerOffset = 20;
                    var elementPosition = smoothCountElement.getBoundingClientRect().top;
                    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });
                }
            }
        } else {

            $('button#AddToCart-product-template.product-form__cart-submit').click();
            $('.gvlo-trigger').remove();
            $('.gvlo-popup-modal--inner').remove();
            $('.gvlo-body-blackout').css('display', 'none');
            $('#govaloApp').css('display', 'none');
        }


    });

});

/****************************************************************************************************************
    // filter sizes to match the selected color
****************************************************************************************************************/
function SetSizeSelect(sizeColor, allSizeSelectOptions) {
    $(`#SingleOptionSelector-1`).empty(); // clear out the size select
    $.each(allSizeSelectOptions, function (i) { $(`#SingleOptionSelector-1`).append(allSizeSelectOptions[i]); }); // repopulate size select box with ALL values
    var firstOfColor = $(`#SingleOptionSelector-1 option[data-size-color='${sizeColor}']:first`).val(); // find the first value of our selected color
    $(`#SingleOptionSelector-1 option[data-size-color]:not([data-size-color='${sizeColor}'])`).remove(); // remove all but our selected color
    $(`#SingleOptionSelector-1`).val(`${firstOfColor}`); // set select to the first instance of our selected color

    $(`.pdp-size-swatch:not([data-size-color='${sizeColor}'])`).addClass('hidden-swatch');
    $(`.pdp-size-swatch[data-size-color='${sizeColor}']`).removeClass('hidden-swatch');
    $(".pdp-size-swatch").removeClass('active');
    OneOptionSize(sizeColor);
}
/****************************************************************************************************************
    // Select the only option 
****************************************************************************************************************/
function OneOptionSize(sizeColor) {
    var sizeContainer = document.querySelectorAll(`.pdp-size-swatch[data-size-color='${sizeColor}']`).length;

    if (sizeContainer == 1) {
        $(`.pdp-size-swatch[data-size-color='${sizeColor}']`).addClass('active');
        setTimeout(function () {
            $(`.pdp-size-swatch[data-size-color='${sizeColor}']`).click();
        }, 100);
    }
}
/****************************************************************************************************************
    // filter thumbnails to match the selected color
****************************************************************************************************************/
var isGalleryFiltered = false;
function SetImages(swatchColor, allThumbnails) {
    const clearFiltering = new Event('clearFiltering');
    document.dispatchEvent(clearFiltering);
    $(`.product-v2--grid-item:not([data-li-color='${swatchColor}'])`).addClass('disabled-item').hide();
    $(`.product-v2--grid-item[data-li-color='${swatchColor}']`).removeClass('disabled-item').show();
    const filteredImages = new Event('SetImagesFired');
    document.dispatchEvent(filteredImages);
}
/****************************************************************************************************************
    // filter swatch label (color name in text) to match the selected color
****************************************************************************************************************/
function SetColorName(swatchColor) {
    var cssColorName = swatchColor.toLowerCase().replace(/ /g, '-').replace(/\//g, '-').replace(/\./g, ''); // {{ value | downcase | replace: ' ', '-' | replace: '/', '-'}}
    $(`.pdp-swatch-label[data-color-label]:not([data-color-label='${cssColorName}'])`).addClass('hidden-swatchLabel'); // hide all but selected color
    $(`.pdp-swatch-label[data-color-label=${cssColorName}]`).removeClass('hidden-swatchLabel'); // show selected color
    $(`.pdp-swatch-label`).css("visibility", "visible"); // show now that the page load is complete and our list is filtered
    $(`.pdp-tt[data-color="${swatchColor}"]`).addClass('active');
}

$(".payment_button_form--section").on('click', function (e) {
    if ($(".payment_button_form").hasClass('disabled')) {
        e.preventDefault(); 
        e.stopPropagation(); 
        $('.pdp-error').slideDown(100);
    }
});